import { User } from '@auth0/auth0-react';

export enum Role {
  Admin = 'Manager / Admin',
  SaviUser = 'SAVI User',
  SatoUser = 'SATO User',
  SatoVideoReviewer = 'mk_SATO Video Reviewer',
  SaviSatoUser = 'SAVI & SATO User',
  MkSystemAdmin = 'mk_system_admin',
  MkSystemOperator = 'mk_system_operator',
}

export const userRolesIndex = 'https://savi.maxkelsen.com/roles';

export interface SaviWebAuth0User extends User {
  'https://savi.maxkelsen.com/roles': Role[];
  org_id: string;
}

/**
 * @example {"error":"access_denied","error_description":"user auth0|123abc is not part of the org_123abc organization"}
 * @example {"error":"access_denied","error_description":"Please change your password"}
 */
export type Auth0Error = {
  error: 'access_denied' | string;
  error_description: string;
};
